const cookie = require('./cookie')

function setAuthToken (body) {
  const { authToken } = body
  const { ttl } = body
  if (ttl) {
    cookie.set('mtAuthToken', authToken, ttl / 1000)
  } else {
    cookie.set('mtAuthToken', authToken)
  }
}

module.exports = setAuthToken
